module.exports = "/assets/2890eafef06659a163ccabd1bb7f8b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/O2.png
// module id = 1665
// module chunks = 0